export default "__VITE_ASSET__ca683930__"